import * as React from 'react';
import { isEmpty } from 'lodash';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { getTrackingFlowSubType } from 'utils/analytics';

import { translate } from 'components/translate-hoc';
import Spinner from 'components/spinner/spinner.component';

import AdditionalInfoForm from './additional-info-form';

import { TEXT_KEYS, INITIAL_ANALYTICS_DATA, ON_NEXT_CLICK_ANALYTICS_DATA } from './additional-info.constants';

import { IRedemptionAdditionalInfoContainerProps } from './additional-info.types';

import './additional-info.styles.less';

class RedemptionAdditionalInfo extends React.PureComponent<IRedemptionAdditionalInfoContainerProps> {
    public componentDidMount() {
        const { additionalFields, widgetName, redeemGift } = this.props;

        if (isEmpty(additionalFields)) {
            return redeemGift();
        }

        return AnalyticsService.sendFlowEvent({
            ...INITIAL_ANALYTICS_DATA,
            flowSubType: getTrackingFlowSubType(widgetName),
        });
    }

    public onSubmit = (formData: object): void => {
        const { redeemData, widgetName } = this.props;
        const details = Object.entries(formData).map(([key, value]) => ({
            key,
            value
        }));

        this.props.redeemGift({
            ...redeemData,
            details
        });

        AnalyticsService.sendFlowEvent({
            ...ON_NEXT_CLICK_ANALYTICS_DATA,
            flowSubType: getTrackingFlowSubType(widgetName),
        });
    };

    private renderForm = (): JSX.Element => {
        const { activeLanguageCode, additionalFields } = this.props;

        return (
            <AdditionalInfoForm
                onSubmit={this.onSubmit}
                activeLanguageCode={activeLanguageCode}
                fields={additionalFields}
            />
        );
    };

    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, fetching, additionalFields } = this.props;

        const additionalInfoTitle: string = translateKey(TEXT_KEYS.ADDITIONAL_INFO_TITLE);
        const additionalInfoMessage: string = translateKey(TEXT_KEYS.ADDITIONAL_INFO_MESSAGE);

        return (
            <div className="sitegen-redeem-additional-info">
                <div className="sitegen-redeem-additional-info__title">{additionalInfoTitle}</div>
                <div className="sitegen-redeem-additional-info__message">{additionalInfoMessage}</div>
                <div className="sitegen-redeem-additional-info__form-container">
                    {isEmpty(additionalFields) || fetching ? <Spinner /> : this.renderForm()}
                </div>
            </div>
        );
    }
}

export default translate()(RedemptionAdditionalInfo);
